module.exports = __webpack_public_path__ + "static/media/krx-trading-krx-00.b3fd5056.jpg";